import React from 'react';
import P, { InferProps } from 'prop-types';
import { useCollection } from 'react-firebase-hooks/firestore';
import { Typography } from '@mui/material';
import SubCollections from './sub-collections';
import ListItemLink from './list-item-link';
import firebaseApp from '../../../firebase-app';
import { getDescriptionFromDocByPath } from '../../../utils/doc-title-desc-image';
import BreadCrumbs from './breadcrumbs';
import { useStringsContext } from '../../../contexts/strings';
import { collection } from 'firebase/firestore';

function TimeMachineCollection({ path }: InferProps<typeof TimeMachineCollection.propTypes>) {
  const [ref, loading, error] = useCollection(collection(firebaseApp.db, path));
  const { strings } = useStringsContext();

  const renderContent = () => {
    if (loading) {
      return (
        <>
          <Typography>{path}</Typography>
          <p>{strings.messages.loading}</p>
        </>
      );
    }

    if (error) {
      return (
        <>
          <Typography>{path}</Typography>
          <p>{error.message}</p>
        </>
      );
    }

    return (
      <>
        {ref?.docs.reverse().map((d: any) => {
          const docPath = encodeURIComponent(d.ref.path);
          return (
            <ListItemLink
              key={d.ref.path}
              to={`/time-machine/${docPath}`}
              primary={d.ref.id}
              secondary={getDescriptionFromDocByPath(d)}
            />
          );
        })}
      </>
    );
  };

  return (
    <>
      <BreadCrumbs path={path} />
      <SubCollections>{renderContent()}</SubCollections>
    </>
  );
}

TimeMachineCollection.propTypes = {
  path: P.string.isRequired,
};

export default TimeMachineCollection;
